import React, { useEffect, useState } from 'react'
import { Button, Dropdown } from 'antd';
import { RefLanguage } from '../hooks/LanguageHooks';
import * as con from "../Constants"
import { RefStoredValue } from '../hooks/StoreHooks';
import { RefAnnotationData } from '../hooks/AnnotationResultsHook';
import { isNullOrUndefined } from '../utils/generalFunctions';
import { setStoredValue } from '../store/actions';
import { CaretDownOutlined } from '@ant-design/icons';
import DnaIcon from '../elements/DnaIcon';

// const { Text } = Typography

function ResultQueryDropdown() {

    const i18n = RefLanguage()

    const data = RefAnnotationData()

    const [querySequencesIds, setQuerySequencesIds] = useState(null)

    const selectedQueryId = RefStoredValue(con.SELECTED_ANNOTATION_QUERY_ID)

    const selectResultQuery = (e) => {

        if (!isNullOrUndefined(data)) {
            let queryID = e.key

            // Checks if the id exists
            let index = data.findIndex((r) => r[con.ARC_QUERY_ID] === queryID)
            if (index >= 0)
                setStoredValue(con.SELECTED_ANNOTATION_QUERY_ID, queryID)

        }
    }

    useEffect(() => {

        if (isNullOrUndefined(data))
            setQuerySequencesIds(null)
        else {
            let ids = data.map(r => r[con.ARC_QUERY_ID]).filter(id => !isNullOrUndefined(id))
            setQuerySequencesIds(ids)
        }

    }, [data])

    return (
        <div data-tour="query-dropdown" style={{ marginTop: "0.5vh", display: "flex", justifyContent: "center" }}>
            {
                isNullOrUndefined(data) || isNullOrUndefined(querySequencesIds)
                    ? <div style={{ 
                        padding: "8px 16px", 
                        backgroundColor: "#f5f5f5", 
                        borderRadius: "6px",
                        border: "1px dashed #d9d9d9",
                        textAlign: "center",
                        color: "#666"
                      }}>
                        <p style={{ margin: 0 }}>{i18n.t("noResults")}</p>
                      </div>
                    : <Dropdown 
                        menu={{
                            items: querySequencesIds.map(id => ({
                                key: id,
                                label: (
                                    <span style={{ fontFamily: 'monospace' }}>
                                        {id}
                                    </span>
                                )
                            })),
                            onClick: selectResultQuery
                        }}
                        trigger={['click']}
                    >
                        <Button style={{
                            backgroundColor: "var(--primary-color-2)",
                            borderColor: "var(--primary-color-2)",
                            color: "var(--button-text-color)",
                            fontWeight: "var(--button-font-weight-strong)",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        }}>
                            <DnaIcon style={{ width: "14px", height: "14px" }} />
                            {isNullOrUndefined(selectedQueryId) 
                                ? `${i18n.t("selectQuerySequence")}`
                                : <span>{i18n.t("queryLabel")} <span style={{ fontFamily: 'monospace' }}>{selectedQueryId}</span></span>
                            }
                            <CaretDownOutlined />
                        </Button>
                    </Dropdown>
            }

        </div >
    )
}

export default ResultQueryDropdown
